import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "agency-dashboard container-fluid",
  "aria-label": "Agency dashboard"
}
const _hoisted_2 = {
  class: "agency-selector mb-3",
  "aria-labelledby": "agency-selector-heading"
}
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "col-3" }

import {ref, watch, nextTick} from "vue";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import {BAgency} from "./Fields";
import AgencyOverview from "./AgencyDashboard/AgencyOverview.vue";
import AgencyNotice from "./AgencyDashboard/AgencyNotice.vue";
import AgencySubmission from "./AgencyDashboard/AgencySubmission.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyDashboard',
  setup(__props) {

const agency = ref();
const dashboardContent = ref<HTMLElement | null>(null);

watch(agency, async () => {
    await nextTick();
    dashboardContent.value?.focus();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", {
        id: "agency-selector-heading",
        class: "visually-hidden"
      }, " Select agency ", -1)),
      _createElementVNode("form", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("label", {
          id: "agency-label",
          for: "agency",
          class: "align-self-center me-3"
        }, " Select Agency ", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(BAgency), {
            name: "agency",
            modelValue: agency.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agency).value = $event)),
            "can-clear": false,
            "select-first": true,
            "aria-labelledby": "agency-label",
            "aria-required": "true"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("section", {
      ref_key: "dashboardContent",
      ref: dashboardContent,
      class: "dashboard-content",
      "aria-labelledby": "dashboard-content-heading",
      "aria-live": "polite",
      "aria-atomic": "false"
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", {
        id: "dashboard-content-heading",
        class: "visually-hidden"
      }, " Agency dashboard updates ", -1)),
      _createVNode(AgencyNotice, { ori: agency.value }, null, 8, ["ori"]),
      _createVNode(AgencySubmission, { ori: agency.value }, null, 8, ["ori"]),
      _createVNode(AgencyOverview, { ori: agency.value }, null, 8, ["ori"])
    ], 512),
    _createVNode(SystemAlerts)
  ]))
}
}

})